import { getCorporationRefundData } from '@/components/tax-refund/common/data/corporation-refund-data';
import { getIndisSearchRefundData } from '@/components/tax-refund/common/data/indis-search-refund-data';
import { LookupResultRefundDataContextType, BusinessType } from '@/lib/types/request';

export function getRefundDataForWebStorage(type: BusinessType) {
  const data = {} as Omit<LookupResultRefundDataContextType, 'businessType'> & { refundAmount: string };

  if (type === 'corps') {
    const corpData = getCorporationRefundData();
    Object.assign(data, {
      refundId: corpData?.refundId || '',
      refundAmount: corpData?.refundAmount || '',
      refundStatus: corpData?.refundStatus || '',
      displayName: corpData?.bizName || '고객'
    });
  } else {
    const indisData = getIndisSearchRefundData();
    Object.assign(data, {
      refundId: indisData?.refundId || indisData?.tritxRefundInfo?.refundId || '',
      refundAmount: indisData?.refundAmount || '',
      refundStatus: indisData?.refundStatus || '',
      displayName: indisData?.bizName || indisData?.tritxRefundInfo?.businessInfo?.taxpayerName || '고객',
      snmcSpcTxreAmt: indisData?.snmcSpcTxreAmt || 0,
      cenSnmcTxreAmt: indisData?.cenSnmcTxreAmt || 0,
      empIncrEtrpTxamtDdcAmt: indisData?.empIncrEtrpTxamtDdcAmt || 0,
      intgEmpTxamtDdcAmt: indisData?.intgEmpTxamtDdcAmt || 0,
      sctyInfeeTxamtDdcAmt: indisData?.sctyInfeeTxamtDdcAmt || 0,
      tritxRefundInfo: indisData?.tritxRefundInfo
    });
  }

  return data;
}
